import { CartAbandonmentHeartbeatAPIRequestCart } from "./mappers/CartAbandonmentHeartbeatAPIRequestCart";
import { CartAbandonmentHeartbeatAPIRequestPromoCodes } from "./mappers/CartAbandonmentHeartbeatAPIRequestPromoCodes";
import { requestCartAbandonment } from "../../../utils/witbookingApi";
export class CartAbandonmentHeartbeatAPI {
    static async sendHeartbeat(data) {
        const payload = {
            cart: CartAbandonmentHeartbeatAPIRequestCart.of(data.bookingCart),
            email: data.loyaltyUser.email,
            locale: data.locale,
            promoCodes: CartAbandonmentHeartbeatAPIRequestPromoCodes.of(data.bookingCart),
            urlParams: data.urlParams,
        };
        return requestCartAbandonment(data.loyaltyUser.sessionId, payload);
    }
}
